













































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { AcgnPop } from '@acgn/herm/src/ui';
import { namespace } from 'vuex-class';
const ComicAction = namespace('desk/comic').Action;
const ComicGetter = namespace('desk/comic').Getter;

export interface TargetEditType { // 编辑结构类型
  template_name: string;
  process_code: string;
  project_type: number;
  orders: number;
}

@Component({
  components: {
    AcgnPop
  }
})

/**
 * 审批流程组件
 */
export default class AcgnProcedureEdit extends Vue {
  @Prop({ default: [] }) public workflowList: any; // 类型列表
  @Prop() public isSort: any; // 是否排序
  @Prop() public getNewWork: any; // 获取排序后的值
  @Prop({ default: false }) public isBaseInstall: any; // 是否默认
  @Prop() public getFlowList: any;
  @ComicAction private addTemplateLink: any; // 添加环节
  @ComicAction private delTemplateLink: any; // 删除环节
  @ComicGetter private loadings: any; // 章节loading
  private draging: any;
  private target: any;
  private visible: any = false;
  private formData: TargetEditType = {
    template_name: '',
    process_code: '',
    project_type: 1,
    orders: 1
  };

  @Watch('visible')
  private getVisible() {
    this.formData = {
      template_name: '',
      process_code: '',
      project_type: 1,
      orders: 1
    };
  }

  // 拖动相关
  private onDragStart(event: any) {
    this.draging = event.target;
  }
  private onDragOver(event: any) {
    this.target = event.target;
    if (this.target.className === 'acgn-operate_list' && this.target !== this.draging) {
      if (this._index(this.draging) < this._index(this.target)) {
        this.target.parentNode.insertBefore(this.draging, this.target.nextSibling);
      } else {
        this.target.parentNode.insertBefore(this.draging, this.target);
      }
    }
  }

  // 拖动结束
  private onDragEnd(event: any) {
    const currentNodes = Array.from((this.$refs.parentNode as any).childNodes);
    const data = currentNodes.map((i: any, index) => {
      const str = i.getElementsByTagName('input')[0].value;
      const item = this.workflowList.find((c: any) => c.template_name === str);
      return item;
    });
    this.getNewWork(data);
  }
  private _index(el: any) {
    const domData = Array.from((this.$refs.parentNode as any).childNodes);
    return domData.findIndex((i: any ) => i.innerText === el.innerText);
  }
  // 拖动相关结束

  private getAddProcessCode(code: any) {
    const process_code  = code;
    let temp = this.getQueryVariable(process_code, 'processCode');
    if (temp) {
      if (temp.lastIndexOf('#') !== -1) {
        temp = temp.substring(0, temp.lastIndexOf('#'));
      }
      this.formData.process_code = temp;
    }
  }

  // 输入框复制
  private getProcessCode(item: any) {
    const { process_code } = item;
    let temp = this.getQueryVariable(process_code, 'processCode');
    if (temp) {
      if (temp.lastIndexOf('#') !== -1) {
        temp = temp.substring(0, temp.lastIndexOf('#'));
      }
      item.process_code = temp;
    }
  }

  private getQueryVariable(item: any, variable: any) {
    const query = item;
    const vars = query.split('&');
    for (const i of vars) {
      const pair = i.split('=');
      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return false;
  }

  // 提交
  private async submit() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (!valid) {
        return;
      }
      try {
        if (this.isBaseInstall) {
          const params = { ...this.formData, name: this.formData.template_name };
          if (this.workflowList.length > 0) {
            params.orders = this.workflowList[this.workflowList.length - 1].orders + 1; // 取列表orders的最大值加一。
          } else {
            params.orders = 1;
          }
          await this.addTemplateLink(params);
          this.$message.success('添加成功');
          this.visible = false;
          this.getFlowList();
          return false;
        }
      } catch (ex) {
        this.$message.error(this.$language.error);
        return false;
      }
      this.workflowList.push({...this.formData});
      this.visible = false;
    });
  }

  // 取消
  private close() {
    this.visible = false;
  }

  // 获取表单验证规则
  private get rules() {
    const rules = {
      template_name: [
        { required: true, message: '请输入创作环节名称', trigger: 'blur' }
      ],
      process_code: [
        { required: true, message: '请输入审批流URL', trigger: 'blur' }
      ],
    };
    return rules;
  }

  // 添加环节
  private addSegment() {
    this.visible = true;
  }
  // 删除环节
  private delSegment(index: any, item: any) {
    this.$confirm(`确认将“${item.template_name}”删除？`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async () => {
      if (this.isBaseInstall) {
        const params = {template_id: item.id};
        await this.delTemplateLink(params);
        this.$message.success('删除成功');
      }
      this.workflowList.splice(index, 1);
    }).catch(() => {});
  }
}
